import React from "react";
import Layout from "../components/Layout";

function Fulfilment(ctx) {
  return (
    <Layout
      brand={ctx.brand}
      showHeaderLinks={true}
      canonical="https://www.track-night.com/terms"
    >
      <div className="container">
        <div className="section">
          <h1 className="title">Fulfilment</h1>
          <h2 className="subtitle">Delivery policy</h2>
          <p>
            On purchasing a game you will receive an email containing a special
            link that will allow you to get back into your game to start at any
            time. Games do not expire, so you can play whenever you like
          </p>
          <p>
            Alternatively, you can go ahead and play your game straight away
          </p>
          <h2 className="subtitle">Refund policy</h2>
          <p>
            If you are eligable for a refund the funds will be back in the
            account you used to pay within 5-10 business days at the lastest. In
            most cases the funds will be with you within a few hours.
          </p>
          <h2 className="subtitle">Cancellation policy</h2>
          <p>
            Bought a game and no longer wish to play? Unstarted games can be
            cancelled at any time within 1 month. Just get in touch with the
            order details, and we&apos;ll get it sorted.
          </p>
        </div>
      </div>
    </Layout>
  );
}

export default Fulfilment;
